export default {
  // 标题文字
  title: {
    w1: "欢迎注册融资界",
    w2: "欢迎登录融资界",
    w3: "找回密码",
    w4: "最新借款列表",
    w5: "域名质押行业领先，投资回报高效稳健",
    w6: "最新公告",
    w7: "行业资讯",
    w8: "手机验证",
    w9: "邮箱验证",
    w10: "关于我们",
    w11: "帮助中心",
    w12: "投资计算器",
    w13: "借款计算器",
    w14: "官方客服QQ",
    w15: "官方联系电话",
    w16: "阅读协议",
    w17: "我们的优势",
    w18: "安全保障",
    w19: "屏蔽名单",
    w20: "重置登录密码",
    w21: "实名认证",
    w22: "重置交易密码",
    w23: "设置交易密码",
    w24: "修改绑定手机",
    w25: "手机绑定",
    w26: "修改绑定邮箱",
    w27: "邮箱绑定",
    w28: "修改银行卡",
    w29: "添加银行卡",
    w30: "添加屏蔽用户名单",
    w31: "修改联系地址",
    w32: "设置联系地址",
    w33: "投资列表",
    w34: "质押域名",
    w35: "还款信用",
    w36: "平台认证信息",
    w37: "质押域名类型",
    w38: "平台公告",
    w39: "公告详情",
    w40: "新闻资讯",
    w41: "新闻详情",
    w42: "通知设置",
    w43: "玉米粒记录",
    w44: "玉米粒兑换",
    w45: "填写借款信息",
    w46: "确认借款信息",
    w47: "投资",
    w48: "借款",
    w49: "域名质押管理",
    w50: "信用周转记录",
    w51: "申请解除质押域名",
    w52: "修改注册商",
    w53: "绑定注册商",
    w54: "申请质押",
    w55: "冻结详情",
    w56: "完善信息",
    w57: "撤销投资",
    w58: "撤销借款",
    w59: "本期还款",
    w60: "提前还款",
    w61: "帮助详情",
    w62: "邀好友领奖励上不封顶",
    w63: "我的奖金:",
    w64: "我的奖金 > 管理费账户",
    w65: "下载协议",
    w66: '请输入手机验证码',
    w67: '优惠券',
    w68: '管理费减免券',
    w69: '有效期',
    w70: '不使用减免券',
    w71: '优惠券减免'
  },
  // 导航、链接 性质的文字
  nav: {
    w1: "我要投资",
    w2: "我要借款",
    w3: "查看更多",
    w4: "投资流程",
    w5: "借款流程",
    w6: "立即开启",
    w7: "立即前往",
    w8: "资产中心",
    w9: "充值",
    w999: "去充值",
    w10: "提现",
    w11: "信用周转",
    w12: "资金记录",
    w13: "域名管理",
    w14: "批量质押域名",
    w15: "批量解除质押",
    w16: "注册商管理",
    w17: "批量解除域名",
    w18: "批量质押域名",
    w19: "申请授信",
    w20: "账号设置",
    w21: "提现银行管理",
    w22: "我的订单",
    w23: "投资订单",
    w24: "借款订单",
    w25: "自动投标",
    w26: "创建投标",
    w27: "回款续投配置",
    w28: "首页",
    w29: "上页",
    w30: "下页",
    w31: "末页",
    w32: "网站公告",
    w33: "新闻资讯",
    w34: "网站声明",
    w35: "企业简介",
    w36: "常见问题",
    w37: "我是借款人",
    w38: "我是投资人",
    w39: "通知",
    w40: "我的订单",
    w41: "资产中心",
    w42: "账户设置",
    w43: "域名管理",
    w44: "自动投标",
    w45: "我的卡券",
    w46: "安全退出",
    w47: "兑换卡券",
    w48: "登录",
    w49: "注册",
    w50: "借款人信息",
    w51: "投资记录",
    w52: "还款记录",
    w53: "有效配置",
    w54: "失效配置",
    w55: "手动创建投标",
    w56: "银行卡管理",
    w57: "去借款",
    w58: "忘记交易密码",
    w59: "邮箱验证",
    w60: "手机验证",
    w61: "手机注册",
    w62: "邮箱注册",
    w63: "密码登录",
    w64: "动态登录",
    w65: "忘记密码",
    w66: "点击注册",
    w67: "批量解除",
    w68: "批量删除",
    w69: "批量质押",
    w70: "快速还款",
    w71: "查看屏蔽名单",
    w72: "马上投资",
    w73: "等待还款",
    w74: "转移至管理费账户",
    w75: "选择订单数",
    w76: "还款期数",
    w77: "本息总额(元)",
    w78: "资金账户余额(元)",
    w79: "管理费总额(元)",
    w80: "管理费账户余额(元)",
    w81: "还需充值",
    w82: "还款计数器",
    w83: "一键还款",
    w84: "借款描述",
    w85: "查看更多"
  },
  // label文字，表单label，描述性label，表头文字
  label: {
    w1: "投资金额",
    w2: "借款金额",
    w3: "年利率",
    w4: "投资周期",
    w5: "元",
    w6: "应付利息",
    w7: "每期利息",
    w8: "应缴管理费",
    w9: "每期管理费",
    w10: "借款标",
    w11: "精品域名",
    w12: "100起投",
    w13: "期限",
    w14: "个月",
    w15: "天",
    w16: "金额/姓名/标号",
    w17: "周期",
    w18: "投标进度",
    w19: "操作",
    w20: "登录密码",
    w21: "交易密码",
    w22: "邮箱绑定",
    w23: "手机绑定",
    w24: "实名认证",
    w25: "银行卡管理",
    w26: "联系地址",
    w27: "开户行",
    w28: "银行卡号",
    w29: "绑定日期",
    w30: "选择国家/地区",
    w31: "身份信息",
    w32: "现住址",
    w33: "新交易密码",
    w34: "重复密码",
    w35: "手机验证码",
    w36: "邮箱验证码",
    w37: "原手机验证码",
    w38: "新手机号码",
    w39: "新手机验证码",
    w40: "手机号码",
    w41: "新密码",
    w42: "原邮箱验证码",
    w43: "新邮箱地址",
    w44: "新邮箱验证码",
    w45: "邮箱地址",
    w46: "开户姓名",
    w47: "选择银行",
    w48: "选择地区",
    w49: "开户支行",
    w50: "屏蔽用户",
    w51: "编号",
    w511: "还款期数",
    w52: "利息",
    w53: "状态",
    w54: "期数",
    w55: "管理费",
    w56: "本期本息",
    w57: "还款日期",
    w58: "应还款时间",
    w59: "本期还款",
    w60: "逾期罚金",
    w61: "还款状态",
    w62: "实际还款时间",
    w63: '到期收益',
    w64: "已收本息",
    w65: "本金还款",
    w66: "逾期罚息",
    w67: "平台奖励",
    w68: "投资状态",
    w69: "账户余额",
    w70: "管理费余额",
    w71: "修改年利率",
    w72: "增加",
    w73: "截止日期",
    w74: "投资进度",
    w75: "总利息",
    w76: "总管理费",
    w77: "分{%}期",
    w78: "每期",
    w79: "最后一期本金还款",
    w80: "借款周期",
    w81: "还款方式",
    w82: "借款描述",
    w83: "借款类型",
    w84: "标剩余金额",
    w85: "预计利息",
    w86: "满标用时",
    w87: "满标时间",
    w88: "投资人数",
    w89: "发标时间",
    w90: "截止时间",
    w91: "下期还款时间",
    w92: "本期管理费",
    w93: "还款结束时间",
    w94: "借款本息",
    w95: "已付管理费",
    w96: "域名",
    w97: "品类",
    w98: "授信总额",
    w99: "已用授信",
    w100: "本标占比",
    w101: "投资人",
    w102: "投资时间",
    w103: "优惠券",
    w104: "近半年",
    w105: "近一年",
    w106: "总计",
    w107: "逾期",
    w108: "提前",
    w109: "正常",
    w110: "违约",
    w111: "姓名",
    w112: "共发布贷款数",
    w113: "近半年有无逾期",
    w114: "性别",
    w115: "年龄",
    w116: "注册日期",
    w117: "手机认证",
    w118: "邮箱认证",
    w119: "授信总额",
    w120: "授信占比",
    w121: "域名个数",
    w122: "发件人",
    w123: "时间",
    w124: "通知",
    w125: "公告",
    w126: "线下通知方式",
    w127: "有效期",
    w128: "玉米粒",
    w129: "类型",
    w130: "余额",
    w131: "受理时间",
    w132: "适用于",
    w133: "使用说明",
    w134: "有效时间",
    w135: "温馨提示",
    w136: "选填",
    w137: "管理费率",
    w138: "到期还款金额",
    w139: "私标对象",
    w140: "可用额度",
    w141: "最多可借",
    w142: "优惠减免",
    w143: "配置状态",
    w144: "保留金额",
    w145: "最低利率",
    w146: "域名类型",
    w147: "可用金额",
    w148: "已投资金额",
    w149: "投标总额",
    w150: "域名品类",
    w151: "失效时间",
    w152: "创建时间",
    w153: "标号",
    w154: "投资日期",
    w155: "投资总额",
    w156: "提现账户",
    w157: "提现金额",
    w158: "可提现",
    w159: "账户",
    w160: "注册商",
    w161: "注册ID",
    w162: "验证信息",
    w163: "日期",
    w164: "收入",
    w165: "支出",
    w166: "账户总额",
    w167: "说明",
    w168: "可用余额",
    w169: "冻结金额",
    w170: "私标",
    w171: "周转标",
    w172: "管理费账户可用余额",
    w173: "本月需还款",
    w174: "管理费冻结资金",
    w175: "最近一个月内预计收益",
    w176: "已投资",
    w177: "待收款",
    w178: "累计收益",
    w179: "最近一个月内还需还款",
    w180: "已借款",
    w181: "待还款",
    w182: "违约欠款",
    w183: "个",
    w184: "可用授信",
    w185: "已授信域名",
    w186: "已质押域名",
    w187: "授信时间",
    w188: "域名状态",
    w189: "借款状态",
    w190: "信用额度",
    w191: "大写额度",
    w192: "申请时间",
    w193: "周转额度",
    w194: "关联项目",
    w195: "账号",
    w196: "我的域名",
    w197: "授信金额",
    w198: "冻结日期",
    w199: "账户名",
    w200: "密码",
    w201: "验证码",
    w202: "新登录密码",
    w203: "月",
    w204: "利率",
    w205: "金额",
    w206: "投资返现",
    w207: "邀请码",
    w208: "邀请人数",
    w209: "累计奖励",
    w210: "邀请链接",
    w211: "复制链接",
    w212: "邀请记录",
    w213: "奖励记录",
    w214: "序号",
    w215: "好友",
    w216: "注册时间",
    w217: "奖励时间",
    w218: "奖励类型",
    w219: "奖励金额(元)",
    w220: "转移金额",
    w221: "滑动验证",
    w222: "已开启",
    w223: "已关闭",
    w224: "开启",
    w225: "关闭",
    w226: '应收利息',
    w227: '应付管理费',
    w228: '每期管理费',
    w229: '预计收益',
    w230: '每期收益',
    w231: '预计收益',
    w232: '收益',
    w233: `<div class='daoqi'>到期收益<i class="icon-active1 pre1" onclick="toCheck()"/></div>`,
    w234: '到期利息',
    w235: '手机号(必须是绑定该身份证的手机号码！)'
  },
  // 输入框placeholder
  pl: {
    p1: "手机/邮箱",
    p2: "请输入邮箱验证码",
    p3: "8-16位数字、字母或字符组合",
    p4: "请再次输入密码",
    p5: "手机/邮箱/ID",
    p6: "请输入密码",
    p7: "请输入手机号",
    p8: "请输入验证码",
    p9: "请输入邮箱地址",
    p10: "请输入要授信的域名，每行一个，一次最多500个",
    p11: "请输入交易密码",
    p12: "开始时间",
    p13: "请输入",
    p14: "手机",
    p15: "邮箱",
    p16: "验证码",
    p17: "请输入额度",
    p18: "请输入域名",
    p19: "结束时间",
    p20: "请输入100的整数倍，且不小于1000",
    p21: "请输入保留金额",
    p22: "请输入需要搜索的关键字",
    p23: "请输入100元的整数倍",
    p24: "请输入联系地址",
    p25: "请输入要屏蔽的用户姓名",
    p26: "如：科技园支行",
    p27: "请输入银行卡号",
    p28: "请输入手机验证码",
    p29: "请再次输入新密码",
    p30: "请输入短信验证码",
    p31: "请输入邮箱验证码",
    p32: "不超过{%}%",
    p33: "请联系客服获取邀请码",
    p34: "请输入订单号",
    p35: '请输入域名',
    p36: "订单号",
    p37: '域名',
    p38: '搜索'
  },
  // 提示信息，弹出提示信息，输入框错误提示信息
  msg: {
    m1: "未找到相关数据",
    m2: "请上传身份证头像页",
    m3: "只允许上传.jpg和.png的文件",
    m4: "香港居民身份证头像页",
    m5: "护照信息页照",
    m6: "请再次输入密码",
    m7: "两次输入密码不一致",
    m8: "还没有账号？",
    m9: "已有账号？",
    m10: "请先将您的域名PUSH到以下指定账户，PUSH完成后再提交质押申请。",
    m11: "已存在",
    m12: "提交失败",
    m13: "个成功",
    m14: "个失败",
    m15: "域名解除质押后将push到以下账户，请确认。",
    m16: "1、请上传清晰图片，若添加水印、遮挡物可能无法识别。",
    m17: "3、仅支持.jpg .png的图片格式，图片大小不得超过15M。",
    m18: "身份证识别失败",
    m19: "您所提交的身份证图片无法识别或已被使用，请重新上传清晰的图片，如有疑问，请联系客服人员。",
    m20: "提交失败！",
    m21: "提交成功！",
    m22: "加入屏蔽名单的用户自动投标将被屏蔽",
    m23: "是否确定删除此银行卡？",
    m24: "删除成功",
    m25: "现住址不能为空",
    m26: "手机号不能为空",
    m27: "手机号码格式不正确",
    m28: "手机号码不正确",
    m29: "取消屏蔽成功",
    m30: "认证成功",
    m31: "两次密码输入不一致",
    m32: "密码不能为空",
    m33: "重置成功",
    m34: "设置成功",
    m35: "手机绑定修改成功",
    m36: "绑定成功",
    m37: "登录密码已重置，请重新登录！",
    m38: "绑定邮箱修改成功",
    m39: "开户支行不能为空",
    m40: "修改成功",
    m41: "添加成功",
    m42: "屏蔽用户不能为空",
    m43: "添加屏蔽成功",
    m44: "联系地址不能为空",
    m45: "设置成功",
    m46: "没有未读通知",
    m47: "请先选择要删除的通知",
    m48: "当前状态不可申请",
    m49: "请先选择质押域名",
    m50: "确认撤销自动投标",
    m51: "金额不能为空",
    m52: "金额格式不正确",
    m53: "提交成功，请耐心等待审核",
    m54: "请先设置交易密码",
    m55: "是否确定删除该注册商信息？",
    m56: "删除域名",
    m57: "请先绑定",
    m58: "注册商账号",
    m59: "请先选择域名",
    m60: "删除域名选中的域名",
    m61: "请输入正确的金额",
    m62: "请先验证交易密码和验证码",
    m63: "请先阅读并同意《域名价值估算协议》",
    m64: "请先输入域名",
    m65: "一次提交域名不能超过500个",
    m66: "请先实名认证",
    m67: "账号不能为空",
    m68: "验证信息不能为空",
    m69: "该手机已经被使用",
    m70: "邮箱不能为空",
    m71: "邮箱格式错误",
    m72: "该邮箱已经被使用",
    m73: "注册成功！",
    m74: "自动投标可满足{%}%的借款",
    m75: "当前存在质押借款的域名自动拆分单独借款标",
    m76: "您还没有质押域名获取授信额度，不能申请借款。",
    m77: "数据请求失败",
    m78: "退出登录成功",
    m79: "请上传香港居民身份证头像页",
    m80: "请上传护照信息页照",
    m81: "登录状态已失效，请重新登录",
    m82: "验证码不能为空",
    m83: "密码长度必须是8-16位",
    m84: "密码不正确",
    m85: "银行卡号不能为空",
    m86: "不能为空",
    m87: "共{%}个",
    m88: "发布失败",
    m89: "发布成功",
    m90: "还差{%}玉米粒",
    m91: "兑换成功",
    m92: "已发放至 - 我的卡券",
    m93: "质押域名仅借贷双方可见",
    m94: "停止计息",
    m95: "年利率不能小于原年利率",
    m96: "确认撤销投资",
    m97: "确认撤销借款标",
    m98: "余额不足",
    m99: "信用周转",
    m100: "您当前尚无可质押域名",
    m101: "您当前尚无可解除域名",
    m102: "您当前尚无此投资订单",
    m103: "您当前尚无此借款订单",
    m104: "您当前暂无信用周转记录",
    m105: "您当前尚无授信域名",
    m106: "您当前尚无可解除域名",
    m107: "您当前尚无可删除域名",
    m108: "您当前尚无可质押域名",
    m109: "您当前尚无冻结资金",
    m110: "您当前未绑定注册商",
    m111: "您当前尚未创建自动投标",
    m112: "您暂无可用卡券",
    m113: "您暂无已用卡券",
    m114: "您暂无失效卡券",
    m115: "暂无可兑换卡券，敬请期待!",
    m116: "您当前尚无获得玉米粒记录",
    m117: "当前尚无新闻资讯",
    m118: "当前尚无公告",
    m119: "您当前暂无消息记录",
    m120: "当前暂无借款标",
    m121: "您当前尚未添加银行卡",
    m122: "您暂未添加屏蔽名单",
    m123: "2、请提交您本人的证件照，一经认证不可修改。",
    m124: "您当前尚无借款，无需开通管理费账户",
    m125: "优惠券汇率高于或等于实际汇率，不需使用优惠券",
    m126: "本平台管理费率采取阶梯式收取规则",
    m127: "复制成功",
    m128: "复制失败",
    m129: "尚无邀请记录",
    m130: "尚无奖励记录",
    m131: "您当前尚无资金记录",
    m132: "最多可转",
    m133: "密码格式不正确（若原密码格式不正确，请设置新交易密码）",
    m134: "开启成功",
    m135: "关闭成功",
    m136: '邀请码不能为空',
    m137: '邀请码是由数字和字母组成的6位数'
  },
  // 按钮文字
  btn: {
    b1: "我再想想",
    b2: "确认删除",
    b3: "重新上传",
    b4: "下一步",
    b5: "确认",
    b6: "重置",
    b7: "筛选",
    b8: "不同意",
    b9: "同意",
    b10: "立即登录",
    b11: "立即注册",
    b12: "确认质押",
    b13: "确认解除",
    b14: "继续申请授信",
    b15: "返回域名管理",
    b16: "确认申请",
    b17: "退出质押",
    b18: "退出移除",
    b19: "确认移除",
    b20: "申请额度",
    b21: "查询",
    b22: "批量操作",
    b23: "申请授信",
    b24: "退出批量操作",
    b25: "删除",
    b26: "修改",
    b27: "绑定注册商",
    b28: "提现",
    b29: "我再想想",
    b30: "确认撤销",
    b31: "创建投标",
    b32: "发布借款",
    b33: "重新发布",
    b34: "查看卡券",
    b35: "玉米粒兑换",
    b36: "更新设置",
    b37: "全部标为已读",
    b38: "马上投资",
    b39: "撤销",
    b40: "加息",
    b41: "提前还款",
    b42: "本期还款",
    b43: "确认还款",
    b44: "充值",
    b45: "确认屏蔽",
    b46: "提交",
    b47: "保存",
    b48: "重新上传",
    b49: "提交审核",
    b50: "正在验证",
    b51: "添加屏蔽名单",
    b52: "取消屏蔽",
    b53: "去重置",
    b54: "去设置",
    b55: "去修改",
    b56: "去绑定",
    b57: "去认证",
    b58: "重新认证",
    b59: "去管理",
    b60: "添加银行卡",
    b61: "已兑完",
    b62: "立即兑换",
    b63: "保存设置",
    b64: "创建投标",
    b65: "冻结详情",
    b66: "等待还款",
    b67: "发送验证码",
    b68: "{%}s后可重发",
    b69: "收起",
    b70: "详情",
    b71: "解除",
    b72: "质押",
    b73: "全部提取",
    b74: "马上质押",
    b75: "进行中",
    b76: "已还款",
    b77: "已取消",
    b78: "全部",
    b79: "还款",
    b80: "复制链接",
    b81: "生成海报",
    b82: "活动详情",
    b83: "立即邀请",
    b84: "下载到桌面",
    b85: "全部转移",
    b86: "一键还款",
    b87: '我知道了'
  },
  // 选项文字，Select组件内选项
  option: {
    w1: "全选",
    w2: "请选择利率",
    w3: "10%以下",
    w4: "10%～20%",
    w5: "20%以上",
    w6: "请选择周期",
    w7: "1个月以下",
    w8: "1个月～3个月",
    w9: "4个月～6个月",
    w10: "7个月～9个月",
    w11: "10个月～12个月",
    w12: "请选择金额",
    w13: "1万元以内",
    w14: "1万元～10万元",
    w15: "10万元以上",
    w16: "去认证",
    w17: "已认证",
    w18: "当前无待还款订单",
    w19: "信用周转申请审核中",
    w20: "信用周转申请已受理",
    w21: "当前已有信用周转借款标",
    w22: "域名状态",
    w23: "授信审核中",
    w24: "授信失败",
    w25: "已授信",
    w26: "质押审核中",
    w27: "已质押",
    w28: "质押解除",
    w29: "未质押",
    w30: "借款状态",
    w31: "已借款",
    w32: "未借款",
    w33: "全部",
    w34: "资金账户",
    w35: "管理费账户",
    w36: "无",
    w37: "1天",
    w38: "2天",
    w39: "已设置",
    w40: "未设置",
    w41: "未绑定",
    w42: "未认证",
    w43: "审核中",
    w44: "未通过",
    w45: "已绑定",
    w46: "张",
    w47: "屏蔽",
    w48: "邮箱",
    w49: "短信",
    w50: "手动设置",
    w51: "回款续投",
    w52: "已开启",
    w53: "已关闭",
    w54: "{%}%管理费优惠券",
    w55: "先息后本（每月付息，到期还本）",
    w56: "未使用",
    w57: "已使用",
    w58: "已失效",
    w59: "{%}%投资加息券",
    w60: "{%}元投资红包",
    w61: "借款",
    w62: "投资",
    w63: "有",
    w64: "信用周转借款",
    w65: "域名质押借款",
    w66: "{%}人",
    w67: "取消全选",
    w68: "暂不使用优惠券",
    w69: "好友借款",
    w70: "好友投资",
    w71: "奖励金账户",
    w72: "不使用优惠券",
  },
  // 其他，无法归类或归类不明确的文字
  other: {
    w1: "投资人",
    w2: "操作便捷 收益稳健",
    w3: "借款人",
    w4: "域名质押 专业高效",
    w5: "严格风控",
    w6: "甄选优质域名 严格把控风险",
    w7: "安全保障",
    w8: "多重信息技术保障安全",
    w9: "更优质的投资体验，就在融资界",
    w10: "融资界自上线已安全运营超过3年，赢得了超过20000用户的信赖，我们不断超越自己，超越 行业，为用户带来更优质的投资体验",
    w11: "累计会员数(人)",
    w12: "累计成交总额(亿元)",
    w13: "满标平均用时(分钟)",
    w14: "融资界专注深耕域名质押投融资领域，以先进的技术和资深的行业资源，把域名作为质押物，为域名持有人提供高效专业的融资服务，为投资用户提供高效稳健的投资渠道，在投融资用户间搭建一道专业可靠的桥梁。",
    w15: "注册认证",
    w16: "成为会员，身份认证",
    w17: "账户充值",
    w18: "充值汇款，快速到账",
    w19: "选择投资",
    w20: "选择项目，确认投资",
    w21: "获取收益",
    w22: "每月收息，到期回本",
    w23: "申请授信",
    w24: "申请授信，质押域名",
    w25: "发标借款",
    w26: "发布借款，等待投资",
    w27: "资金提现",
    w28: "满标提现，资金到账",
    w29: "没有时间投标？",
    w30: "试试RONGZIJIE自动投标",
    w31: "你的域名值多少钱？",
    w32: "快来了解域名最新行情价格",
    w33: "周一至周五 09:00-18:00",
    w34: "温馨提示：市场有风险，出借需谨慎",
    w35: "2016-2019 WRZ Inc. 粤ICP备16001344号",
    w36: "已有{%}笔投资",
    w37: `<p class="p1">尊敬的用户：</p>
    <p class="p1"> 融资界由HONGKONG PROFIT POWER LIMITED建立并运营，在您使用融资界网站之前，融资界声明如下：</p>
    <p class="p3">（1）融资界仅为注册用户提供域名服务，不向社会公众即社会不特定对象提供服务;</p>
    <p class="p3">（2）融资界不承诺在任何期限内以货币、实物、股权等方式还本付息或者给付回报;</p>
    <p class="p3">（3）融资界非融资主体，不承担任何保证、担保、承兑、刚兑责任，也没有任何偿还投资款的义务;</p>
    <p class="p3"><span>（4）</span><span>融资界的域名信息均系注册用户发布，对注册用户发布的融资信息，您应该准确辨别，识别其中的风险，尤其应该注意会导 致投资款或域名受到损失的风险，包括但不限于政策风险、域名行情风险、信用风险等风险; </span> </p>
    <p class="p3">（5）若发生违约，域名一律通过拍卖、议价、一口价、打包价等方式进行处置。</p>
    <p class="p4">特此声明。</p>
    <p class="p2">HONGKONG PROFIT POWER LIMITED </p>`,
    w38: "您好！请问您需要什么帮助？",
    w39: `<p class="color-g2">融资界，是香港利胜科技有限公司旗下网站，成立于2019年，是专业的全球域名资产服务平台。</p>
    <p class="color-g2">基于对域名行业和金融行业的深刻理解，为用户提供全球域名融资的相关信息，并与国内外多家域名注册商合作，帮助投资人或借款人暂时托管或锁定域名。</p>
    <p class="color-g2">平台基于自身的优势并结合互联网技术为用户搭建一个稳定，便捷，高效，诚信的信息中介服务平台，公司的服务理念是：公平，旨在服务于全球的用户。</p>`,
    w40: "投资收益快",
    w41: "（最短7天回款）",
    w42: "投资零费用",
    w43: "（不收取任何费用）",
    w44: "投资安全",
    w45: "借款便捷",
    w46: "（全部流程线上完成）",
    w47: "借款高效",
    w48: "（最快2小时满标放款）",
    w49: "借款服务优质",
    w50: "（客服一对一服务）",
    w51: "投资安全",
    w52: "（专业风控团队对质押物进行审核）",
    w53: "资金安全",
    w54: "（国际领先的系统加密及保护技术，内部严格的资金管理流程）",
    w55: "数据安全",
    w56: "（采取各种合适的物理、电子和管理方面的措施来保护数据，以实现对数据安全的承诺）",
    w57: "隐私保护",
    w58: "（严格遵守保密责任）",
    w59: "《风险告知书》",
    w60: "《域名投资协议》",
    w61: "《域名信用周转协议》",
    w62: "市场有风险，投资需谨慎",
    w63: "已阅读并同意",
    w64: "逾期{%}天",
    w65: "或",
    w66: "可查看详细信息",
    w67: "投标后是否可以撤销投资？",
    w68: "所有投资的借款项目未满标的情况下，投资人可撤销投资，若所投资的借款项目已满标，则无法撤销投资。若借款人在借款项目未满标时撤销项目或者项目在规定时间内未满标自动流标，则所投资金自动返回投资人账户。",
    w69: "借款利息什么时候计算？",
    w70: "借款利息是从借款项目满标的当天开始计算。",
    w71: "如何收取还款？",
    w72: "借款人在规定的还款时间内将规定的还款金额充值到账户，融资界平台将根据各个投资人的投资比例，自动将投标本息打入投资人账户，并且融资界平台系统会发送邮件、短信、账内信通知投资人，投资人可按个人需求选择提现，或继续投资。",
    w73: "借款人不还钱怎么办？",
    w74: "若借款人未在规定的时间偿还所欠款项，融资界平台将加收所欠款项的0.06%/日作为罚金；同时融资界有权通知域名托管人处置域名，包括不限于拍卖、一口价、直接出售等形式，所得价款清偿所欠款项后，如有余款，融资界将其退还给借款人；如不足，投资人自行承担损失。融资界平台强烈呼吁借款用户尽量避免逾期还款，一旦发生逾期请尽快还清款项，平台有权根据具体情况将用户列入不良信用客户名单。",
    w75: "能提前收回借款吗？",
    w76: "投资资金一旦成功投资，不可提前收回投资的款项，除非借款人自愿提前还清欠款。",
    w77: "共质押域名{%}个，授信总额{%}元",
    w78: '共<span>{%}</span>封，其中未读通知<span class="color-b s1">{%}</span>封',
    w79: "已勾选未读通知 {%} 封",
    w80: "管理员",
    w81: "融资界",
    w82: "我的玉米粒: {%}颗",
    w83: "投资金额{%}元以上",
    w84: "剩余{%}张",
    w85: "自兑换日{%}天内",
    w86: "融资界信用周转",
    w87: "帮您轻松解决资金难题",
    w88: "信用额度融到的资金仅限于还款，不允许提现、投标等其它用途",
    w89: "申请额度：用户提出申请后由平台根据用户个人情况审核并给予一定的额度，每天最多只能申请一次信用周转额度，最低申请额度为1000元",
    w90: "信用额度当天申请当天使用，过期作废，有未偿还的信用周转额度时，不能再次申请额度",
    w91: "使用信用周转额度发布的融资标期限为1-2天；管理费为周转额度的0.6‰/天",
    w92: "截止时间前未满标，则自动取消该笔借款。",
    w93: `<p>1、发布的借款项目满标后则无法撤销，请务必认真填写各项信息；</p>
    <p>2、借款人主动提前还款的，应当按借款期满时应当支付的本金、利息、管理费总额还款，具体以平台计算金额为准；</p>
    <p>3、域名可用额度小于授信额度时，发标后系统将会自动分标；</p>`,
    w94: "输入指定的用户ID作为承接对象，默认为0则不是私标。",
    w95: "截止时间前未满标，则自动取消该笔借款。",
    w96: "{%}个域名",
    w97: "1、如借款人出现违约情况，平台将按照合同处置域名清偿债务，如处置域名所得实际款项不足以偿还债务，投资人需自行承担该风险与损失。融资界不承担担保、兑付责任。",
    w98: "2、特别提醒：回款资金有提现需求的用户请谨慎使用此功能，随时注意开启与关闭，因用户设置不当造成的损失由用户自行承担。",
    w99: "3、已开启自动投标屏蔽，加入屏蔽名单的用户借款标将不被投标，",
    w100: `<p class="tit">
      1.帐户提现到账规则为：
      <br>
      <span>资金账户：工作日9:00-18:00；周末及节假日10:00-16:30。</span>
      <br>
      <span>奖励金及管理费账户：工作日11:00与17:00统一处理提现；周末及节假日不处理提现。 </span>
      <br>
    </p>
    <p>2.为了您的资金安全，请确保提现银行户名与您的真实姓名一致。</p>
    <p>3.提现不收取手续费。</p>
    <p>4.平台禁止洗钱、信用卡套现、虚假交易等行为，一经发现并确认，将终止该账户的使用。</p>`,
    w101: `投资、还本息请充值到<span class='red'>资金账户</span>，支付管理费请充值到<span class="red">管理费账户</span>，两个账户资金不能互转，资金账户的余额无法用于支付管理费。`,
    w102: "请保证您所用于投资的资金来源合法，且是该资金的合法支配 权人，严禁洗钱、信用卡套现等不良行为，一经发现将严厉处 罚，包括但不限于：限制提现、冻结账户。",
    w103: "请转账到以下指定的银行卡账号，并联系客服进行充值。",
    w104: "收款人",
    w105: "林诗意",
    w1051: "魏安阳",
    w106: "中国银行深圳南山支行",
    w107: "开户行",
    w108: "账&nbsp;&nbsp;&nbsp;号",
    w109: "深圳互联利胜科技有限公司",
    w110: "中国光大银行学府路支行",
    w111: "什么是玉米粒？",
    w112: "每成功借款或投资100元，记一玉米粒，可用于兑换活动优惠券。",
    w113: "《域名价值估算协议》",
    w114: "请提交您要申请授信的域名，平台将在1—2个工作日内审核授信。",
    w115: "每个域名占一行，如需提交多个域名，请分行输入，最多可输入500行；",
    w116: "平台只接受有固定价值区间的域名（例如rzj.com）某些域名虽然有很高的价值，但难以评估，平台不提倡质押。",
    w117: "《域名托管协议》",
    w118: "《用户服务协议》",
    w119: "《隐私保护协议》",
    w120: "万",
    w121: "月（待还本金+本次借款",
    w122: "待还本金+本次借款金额",
    w123: "时间周期：1-12个月",
    w124: "邀请好友投资，奖励投资金额*月数*",
    w125: "邀请好友借款，奖励借款金额*月数*",
    w126: "活动规则说明:",
    w127: "1.投资周期为7天和15天，则按7/30和15/30结算奖励。",
    w128: "2.单笔奖金不足0.01CNY则忽略不计。",
    w129: "3.标的满标生效后，奖励一次性发放。",
    w130: "4.活动时间：2019.07.10-2020.07.10。",
    w131: "5.活动最终解释权归融资界所有。",
    w132: "本金",
    w133: "利息",
    w134: "罚金",
    w135: "管理费",
    w136: '平安银行南头城支行',
    w137: '预计收益=利息-管理费',
    w138: '自2020年8月8日起生效的订单，每月将收取投资金额0.1%作为管理费，详情请',
    w139: '查看公告',
    w140: '感谢您一直以来对融资界平台的支持与厚爱！为了让平台更加健康的发展，给您一个更加安全的投资环境，平台风控团队全新升级，增加了更加专业的风控人员，由此也相应增加了公司的管理成本，经过公司高层和风控团队协商后，以对用户权益造成最小影响的前提下，公司会议慎重决定对投资用户适当收取最低金额的管理费，由此给您造成的影响敬请谅解。',
    w141: '管理费收费标准如下：',
    w142: '1.收费标准：投资金额*0.1%/月；',
    w143: '2.收费方式：从投资用户收益中自动扣取相应管理费；',
    w144: '3.收费时间：自2020年8月8日起(该日期后投资的订单将收取相应管理费）；',
    w145: '感谢您一直以来对融资界的关注和支持！如果您有任何疑问请联系平台客服，我们将竭诚为您服务。',
    w147: '我已知悉',
    w148: '重要公告',
    w149: '尊敬的投资用户：',
    w150: '您好!',
    w151: '所有订单均可使用',
    w152: '用于支付管理费'
  }
}
